"use client";
import Image from "next/image";
import Link from "next/link";
import {usePathname} from "next/navigation";
import React, {useEffect, useState} from "react";

// Updated menu data with sectioned submenus
const menuData = [
    {
        id: 1,
        title: "Home",
        path: "/",
    },
    {
        id: 2,
        title: "Products",
        submenu: [
            {
                section: "For Hiring Teams",
                items: [
                    {
                        title: "TalentBoost",
                        path: "/products/TalentBoost",
                        description: "AI-powered hiring platform for recruiters"
                    },
                ]
            },
            {
                section: "For Job Seekers",
                items: [
                    {
                        title: "MockMate",
                        path: "/products/MockMate",
                        description: "Interview preparation for candidates"
                    },
                ]
            },
            // {
            //     section: "",
            //     items: [
            //         {
            //             title: "All Products",
            //             path: "/products",
            //         },
            //         {
            //             title: "Integrations",
            //             path: "/products/integrations",
            //         },
            //     ]
            // }
        ],
    },
    // {
    //     id: 3,
    //     title: "Features",
    //     submenu: [
    //         {
    //             section: "TalentBoost Features",
    //             badge: "For Hiring Teams",
    //             items: [
    //                 {
    //                     title: "AI Candidate Screening",
    //                     path: "/features/talentboost/screening",
    //                 },
    //                 {
    //                     title: "Automated Interview Scheduling",
    //                     path: "/features/talentboost/scheduling",
    //                 },
    //                 {
    //                     title: "Hiring Analytics Dashboard",
    //                     path: "/features/talentboost/analytics",
    //                 },
    //                 {
    //                     title: "ATS Integration",
    //                     path: "/features/talentboost/integrations",
    //                 },
    //             ]
    //         },
    //         {
    //             section: "MockMate Features",
    //             badge: "For Job Seekers",
    //             items: [
    //                 {
    //                     title: "AI Interview Practice",
    //                     path: "/features/mockmate/practice",
    //                 },
    //                 {
    //                     title: "Personalized Feedback",
    //                     path: "/features/mockmate/feedback",
    //                 },
    //                 {
    //                     title: "Industry-Specific Questions",
    //                     path: "/features/mockmate/questions",
    //                 },
    //                 {
    //                     title: "Interview Recording & Review",
    //                     path: "/features/mockmate/recording",
    //                 },
    //             ]
    //         }
    //     ],
    // },
    // {
    //     id: 4,
    //     title: "Use Cases",
    //     submenu: [
    //         {
    //             section: "TalentBoost Use Cases",
    //             badge: "For Hiring Teams",
    //             items: [
    //                 {
    //                     title: "Enterprise Recruitment",
    //                     path: "/use-cases/talentboost/enterprise",
    //                 },
    //                 {
    //                     title: "Technical Hiring",
    //                     path: "/use-cases/talentboost/technical-hiring",
    //                 },
    //                 {
    //                     title: "High-Volume Recruitment",
    //                     path: "/use-cases/talentboost/high-volume",
    //                 },
    //             ]
    //         },
    //         {
    //             section: "MockMate Use Cases",
    //             badge: "For Job Seekers",
    //             items: [
    //                 {
    //                     title: "Tech Interview Prep",
    //                     path: "/use-cases/mockmate/tech-interviews",
    //                 },
    //                 {
    //                     title: "Executive Role Preparation",
    //                     path: "/use-cases/mockmate/executive",
    //                 },
    //                 {
    //                     title: "Career Changers",
    //                     path: "/use-cases/mockmate/career-change",
    //                 },
    //             ]
    //         }
    //     ],
    // },
    {
        id: 5,
        title: "Pricing",
        submenu: [
            {
                section: "TalentBoost Plans",
                badge: "For Hiring Teams",
                items: [
                    {
                        title: "Contact For Sales",
                        path: "/products/TalentBoost#pricing",
                    },

                ]
            },
            {
                section: "MockMate Plans",
                badge: "For Job Seekers",
                items: [
                    {
                        title: "Basic",
                        path: "/products/MockMate#pricing",
                    },
                    {
                        title: "Professional",
                        path: "/products/MockMate#pricing",
                    },
                    {
                        title: "Enterprise",
                        path: "/products/MockMate#pricing",
                    },
                ]
            }
        ],
    },
    {
        id: 8,
        title: "Blog",
        path: '/blog'
    },
    // {
    //     id: 6,
    //     title: "Resources",
    //     submenu: [
    //         {
    //             section: "Learn & Explore",
    //             items: [
    //                 {
    //                     title: "Blog",
    //                     path: "/blog",
    //                 },
    //                 {
    //                     title: "Case Studies",
    //                     path: "/resources/case-studies",
    //                 },
    //                 {
    //                     title: "Webinars",
    //                     path: "/resources/webinars",
    //                 },
    //             ]
    //         },
    //         {
    //             section: "Help & Support",
    //             items: [
    //                 {
    //                     title: "Documentation",
    //                     path: "/docs",
    //                 },
    //                 {
    //                     title: "Knowledge Base",
    //                     path: "/kb",
    //                 },
    //                 {
    //                     title: "FAQs",
    //                     path: "/faqs",
    //                 },
    //             ]
    //         }
    //     ],
    // },
    // {
    //     id: 7,
    //     title: "About",
    //     submenu: [
    //         {
    //             section: "Our Company",
    //             items: [
    //                 {
    //                     title: "About Us",
    //                     path: "/about",
    //                 },
    //                 {
    //                     title: "Team",
    //                     path: "/about/team",
    //                 },
    //                 {
    //                     title: "Careers",
    //                     path: "/careers",
    //                 },
    //             ]
    //         },
    //         {
    //             section: "Connect",
    //             items: [
    //                 {
    //                     title: "Contact",
    //                     path: "/contact",
    //                 },
    //                 {
    //                     title: "Partner Program",
    //                     path: "/partners",
    //                 },
    //                 {
    //                     title: "Press Kit",
    //                     path: "/press",
    //                 },
    //             ]
    //         }
    //     ],
    // },
];

const Header = () => {
    const [navbarOpen, setNavbarOpen] = useState(false);
    const [sticky, setSticky] = useState(false);
    const [openIndex, setOpenIndex] = useState(-1);
    const pathname = usePathname();

    // Toggle navbar for mobile
    const toggleNavbar = () => setNavbarOpen(!navbarOpen);

    // Handle sticky navbar
    useEffect(() => {
        const handleScroll = () => setSticky(window.scrollY >= 80);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Handle submenu toggle
    const toggleSubmenu = (index) => setOpenIndex(openIndex === index ? -1 : index);

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarOpen && !event.target.closest('#navbarCollapse') && !event.target.closest('#navbarToggler')) {
                setNavbarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [navbarOpen]);

    return (
        <header
            className={`header left-0 top-0 z-40 flex w-full items-center ${
                sticky
                    ? "fixed z-[9999] bg-white bg-opacity-80 shadow-sticky backdrop-blur-sm transition dark:bg-gray-dark dark:shadow-sticky-dark"
                    : "absolute bg-transparent"
            }`}
        >
            <div className="container">
                <div className="relative -mx-4 flex items-center justify-between">
                    {/* Logo */}
                    <div className="w-60 max-w-full px-4 xl:mr-12">
                        <Link
                            href="/"
                            className={`header-logo block w-full ${sticky ? "py-5 lg:py-2" : "py-8"}`}
                            aria-label="Home"
                        >
                            <Image
                                src="/images/logo/logo-2.png"
                                alt="Company Logo"
                                width={140}
                                height={30}
                                className="w-full dark:hidden"
                                priority
                            />
                            <Image
                                src="/images/logo/logo.png"
                                alt="Company Logo Dark Mode"
                                width={140}
                                height={30}
                                className="hidden w-full dark:block"
                                priority
                            />
                        </Link>
                    </div>

                    {/* Navbar */}
                    <div className="flex w-full items-center justify-between px-4">
                        <div className="flex-grow">
                            {/* Mobile Menu Toggle */}
                            <button
                                onClick={toggleNavbar}
                                id="navbarToggler"
                                aria-label="Toggle Mobile Menu"
                                aria-expanded={navbarOpen}
                                className="absolute right-4 top-1/2 block translate-y-[-50%] rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden"
                            >
                                <span
                                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${
                                        navbarOpen ? "top-[7px] rotate-45" : ""
                                    }`}
                                />
                                <span
                                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${
                                        navbarOpen ? "opacity-0" : ""
                                    }`}
                                />
                                <span
                                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-white ${
                                        navbarOpen ? "top-[-8px] -rotate-45" : ""
                                    }`}
                                />
                            </button>

                            {/* Navbar Links */}
                            <nav
                                id="navbarCollapse"
                                className={`navbar absolute right-0 z-30 w-[300px] rounded border-[.5px] border-body-color/50 bg-white duration-300 dark:border-body-color/20 dark:bg-dark lg:visible lg:static lg:w-auto lg:border-none lg:bg-transparent lg:p-0 lg:opacity-100 ${
                                    navbarOpen ? "visible top-full opacity-100 px-6 py-4" : "invisible top-[120%] opacity-0"
                                }`}
                            >
                                <ul className="block lg:flex lg:space-x-8">
                                    {menuData.map((menuItem, index) => (
                                        <li key={menuItem.id} className="group relative">
                                            {menuItem.path ? (
                                                <Link
                                                    href={menuItem.path}
                                                    className={`flex py-2 text-base lg:mr-0 lg:inline-flex lg:px-0 lg:py-6 ${
                                                        pathname === menuItem.path
                                                            ? "text-primary dark:text-white"
                                                            : "text-dark hover:text-primary dark:text-white/70 dark:hover:text-white"
                                                    }`}
                                                    aria-current={pathname === menuItem.path ? "page" : undefined}
                                                >
                                                    {menuItem.title}
                                                </Link>
                                            ) : (
                                                <>
                                                    <button
                                                        onClick={() => toggleSubmenu(index)}
                                                        className="flex w-full cursor-pointer items-center justify-between py-2 text-base text-dark hover:text-primary dark:text-white/70 dark:hover:text-white lg:mr-0 lg:inline-flex lg:px-0 lg:py-6"
                                                        aria-expanded={openIndex === index}
                                                    >
                                                        {menuItem.title}
                                                        <span className="pl-3">
                                                          <svg width="15" height="14" viewBox="0 0 15 14"
                                                               aria-hidden="true">
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M3.29289 4.8427C3.68342 4.45217 4.31658 4.45217 4.70711 4.8427L7.5 7.6356L10.2929 4.8427C10.6834 4.45217 11.3166 4.45217 11.7071 4.8427C12.0976 5.23322 12.0976 5.86639 11.7071 6.2569L7.5 10.464L3.29289 6.2569C2.90237 5.86639 2.90237 5.23322 3.29289 4.8427Z"
                                                                fill="currentColor"
                                                            />
                                                          </svg>
                                                        </span>
                                                    </button>

                                                    {/* Enhanced Sectioned Submenu */}
                                                    <div
                                                        className={`submenu relative left-0 top-full rounded-lg bg-white transition-[top] duration-300 group-hover:opacity-100 dark:bg-gray-900 lg:invisible lg:absolute lg:top-[110%] lg:opacity-0 lg:shadow-xl lg:group-hover:visible lg:group-hover:top-full ${
                                                            openIndex === index ? "block" : "hidden"
                                                        } ${menuItem.submenu.length > 1 ? "lg:w-[500px] xl:w-[600px] p-6" : "lg:w-[280px] p-4"}`}
                                                    >
                                                        <div
                                                            className={`${menuItem.submenu.length > 1 ? "grid grid-cols-1 md:grid-cols-2 gap-8" : ""}`}>
                                                            {menuItem.submenu.map((submenuSection, sectionIndex) => (
                                                                <div key={sectionIndex} className="mb-4 last:mb-0">
                                                                    {submenuSection.section && (
                                                                        <div
                                                                            className="flex items-center mb-3 pb-2 border-b border-gray-100 dark:border-gray-700">
                                                                            <h4 className="text-sm font-semibold text-gray-800 dark:text-gray-200">
                                                                                {submenuSection.section}
                                                                            </h4>
                                                                            {submenuSection.badge && (
                                                                                <span
                                                                                    className={`ml-2 px-2 py-0.5 text-xs rounded-full ${
                                                                                        submenuSection.badge.includes("Job Seekers")
                                                                                            ? "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
                                                                                            : "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
                                                                                    }`}>
                                                                                    {submenuSection.badge}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <ul className="space-y-2">
                                                                        {submenuSection.items.map((item, itemIndex) => (
                                                                            <li key={itemIndex}>
                                                                                <Link
                                                                                    href={item.path}
                                                                                    className={`flex flex-col rounded-lg p-3 text-sm transition-all hover:bg-gray-50 dark:hover:bg-gray-800/50 ${
                                                                                        pathname === item.path
                                                                                            ? "bg-gray-50 text-primary dark:bg-gray-800/50"
                                                                                            : "text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-white"
                                                                                    }`}
                                                                                >
                                                                                    <span
                                                                                        className="font-medium flex items-center">
                                                                                        {item.title}
                                                                                        {pathname === item.path && (
                                                                                            <svg
                                                                                                className="w-3 h-3 ml-1.5 text-primary dark:text-white"
                                                                                                fill="currentColor"
                                                                                                viewBox="0 0 20 20">
                                                                                                <path fillRule="evenodd"
                                                                                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                                                                      clipRule="evenodd"/>
                                                                                            </svg>
                                                                                        )}
                                                                                    </span>
                                                                                    {item.description && (
                                                                                        <span
                                                                                            className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                                                            {item.description}
                                                                                        </span>
                                                                                    )}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Optional footer for submenu */}
                                                        {/*{menuItem.title === "Products" && (*/}
                                                        {/*    <div*/}
                                                        {/*        className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">*/}
                                                        {/*        <Link href="/compare"*/}
                                                        {/*              className="flex items-center text-sm font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">*/}
                                                        {/*            <svg className="w-4 h-4 mr-2" fill="none"*/}
                                                        {/*                 stroke="currentColor"*/}
                                                        {/*                 viewBox="0 0 24 24"*/}
                                                        {/*                 xmlns="http://www.w3.org/2000/svg">*/}
                                                        {/*                <path strokeLinecap="round"*/}
                                                        {/*                      strokeLinejoin="round" strokeWidth="2"*/}
                                                        {/*                      d="M9 5l7 7-7 7"></path>*/}
                                                        {/*            </svg>*/}
                                                        {/*            Compare all products*/}
                                                        {/*        </Link>*/}
                                                        {/*    </div>*/}
                                                        {/*)}*/}
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                        {/* CTA Buttons */}
                        <div className="flex items-center justify-end pl-4">
                            {/* Product-specific buttons for TalentBoost and MockMate pages */}
                            {["/products/TalentBoost", "/products/MockMate"].includes(pathname) && (
                                <div className="flex items-center space-x-4">
                                    {/* Demo Link */}
                                    <Link
                                        href={"/#contact"}
                                        className={`hidden md:inline-flex text-sm font-medium transition-colors
                                        ${pathname === "/#contact"
                                            ? "text-gray-700 hover:text-purple-700 dark:text-gray-300 dark:hover:text-purple-400"
                                            : "text-gray-700 hover:text-blue-700 dark:text-gray-300 dark:hover:text-blue-400"
                                        }`}
                                        aria-label={`Book a Demo`}
                                    >
                                        Book a Demo
                                    </Link>

                                    {/* Sign In Button */}
                                    <Link
                                        href={
                                            pathname === "/products/TalentBoost"
                                                ? "https://talentboost.althire.ai/sign-in"
                                                : "https://mockmate.althire.ai/signin"
                                        }
                                        className={`group relative inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-center text-sm font-medium text-white shadow-md transition-all duration-300 hover:translate-y-px hover:shadow-lg focus:outline-none focus:ring-4
                                        ${pathname === "/products/MockMate"
                                            ? "bg-gradient-to-r from-purple-600 to-indigo-700 hover:from-purple-700 hover:to-indigo-800 focus:ring-purple-300 dark:from-purple-700 dark:to-indigo-800 dark:focus:ring-purple-800"
                                            : "bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 focus:ring-blue-300 dark:from-blue-700 dark:to-blue-900 dark:focus:ring-blue-800"
                                        }`}
                                        data-attr={
                                            pathname === "/products/TalentBoost" ? "talentboost-sign-in" : "mockmate-sign-in"
                                        }
                                        aria-label={`Sign in to ${pathname === "/products/TalentBoost" ? "TalentBoost" : "MockMate"}`}
                                    >
                                        <span className="flex items-center gap-2">
                                          <svg
                                              className="w-4 h-4"
                                              fill="currentColor"
                                              viewBox="0 0 20 20"
                                              xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                                fillRule="evenodd"
                                                d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                          </svg>
                                          Sign In
                                          <span
                                              className="absolute -bottom-0 left-1/2 h-0.5 w-0 bg-white transition-all duration-300 group-hover:w-4/5 group-hover:left-[10%]"></span>
                                        </span>
                                    </Link>

                                    {/* Create Account Button */}
                                    <Link
                                        href={
                                            pathname === "/products/TalentBoost"
                                                ? "https://talentboost.althire.ai/sign-up"
                                                : "https://mockmate.althire.ai/signup"
                                        }
                                        className={`hidden md:inline-flex items-center rounded-lg border bg-transparent px-4 py-2 text-sm font-medium transition-colors 
                                        ${pathname === "/products/MockMate"
                                            ? "border-purple-600 text-purple-600 hover:bg-purple-50 dark:border-purple-500 dark:text-purple-400 dark:hover:bg-gray-800"
                                            : "border-blue-700 text-blue-700 hover:bg-blue-50 dark:border-blue-500 dark:text-blue-400 dark:hover:bg-gray-800"
                                        }`}
                                        data-attr={
                                            pathname === "/products/TalentBoost" ? "talentboost-create-account" : "mockmate-create-account"
                                        }
                                        aria-label={`Create a new ${pathname === "/products/TalentBoost" ? "TalentBoost" : "MockMate"} account`}
                                    >
                                        Create Account
                                    </Link>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;